export const getCurrentMonth = () => {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1; // Date.getMonth() returns 0 for January and 11 for December
    return { year: currentYear, month: currentMonth };
}

export const DAY = 1000 * 60 * 60 * 24;
